import { post,get} from '@/utils/network'

const memberApi  = {
    // 设置课程是否允许退课
    setCourseAllowQuit(param:object) {
        return post('/CourseApi/setCourseAllowQuit', param)
    },

    // <---成员接口--- >
    // 教学团队
    getTeacherTeam(param:object) {
        return post('/AssistantApi/getTeacherTeam', param)
    },
    // 教务处排课学生列表
    deptStudentList(params: {
      courseid: string;
      search: string;
      status: number;
      page: number;
      size: number;
    }) {
        return post('Futurev2/Student/deptStudentList', params)
    },
    // 添加助教
    addAssistant(param:object) {
        return post('/AssistantApi/addAssistant', param)
    },
    // 获取行政班列表
    getClassList(param:object) {
        return post('/Futurev2/ClassAdministration/getClassList', param)
    },
    // 获取班级学生列表
    getStudentListByCAid(param:object) {
        return post('/Futurev2/Student/getStudentListByCAid', param)
    },
    // 获取学生列表（本课程不在本大组的学生）
    getStudentList(param:object) {
      return post('/Futurev2/Student/getStudentList', param)
    },
    // 增加班级
    createClass(param:object) {
        return post('/FutureV2/ClassAdministration/createClass', param)
    },
    // 删除行政班
    deleteClass(param:object) {
        return post('/FutureV2/ClassAdministration/deleteClass', param)
    },
    // 行政班改名
    changeName(param:object) {
        return post('/FutureV2/ClassAdministration/changeName', param)
    },

    // <---学生分组接口--- >
    // 行政班改名
    getActivityList(param:object) {
        return post('/Futurev2/Student/getActivityList', param)
    },
    // 获取分组的树状结构（大组小组集合）
    getGroupTree(param:object) {
      return post('/Futurev2/Student/getGroupTree', param)
    },

    // 获取小组列表（包含小组下学生列表）
    getGroupStudent(param:object) {
      return post('/Futurev2/Student/getGroupStudent', param)
    },

    //获取大组详情（包含小组列表）
    getActivityInfo(param:object) {
      return post('/Futurev2/Student/getActivityInfo', param)
    },

    // 获取学生列表（课程id+小组id+搜索词）[可分页]
    getGroupStudentList(param:object) {
      return post('/Futurev2/Student/getGroupStudentList', param)
    },

    // 创建小组
    addGroup(param:object) {
      return post('/CourseGroupApi/addGroup', param)
    },

    // 学生自己主动加入某个小组
    joinGroup(param:object) {
      return post('/CourseGroupApi/joinGroup', param)
    },

    // 学生退组
    quitGroup(param:object) {
      return post('/CourseGroupApi/quitGroup', param)
    },

    // 删除大组
    delGroupActivity(param:object) {
      return post('/CourseGroupActivityApi/delGroupActivity', param)
    },

    // 获取学生列表（本课程不在本大组的学生）
    getStudentListByNotInActivity(param:object) {
      return post('/Futurev2/Student/getStudentListByNotInActivity', param)
    },

    // 获取小组列表
    getGroupList(param:object) {
      return post('/Futurev2/Student/getGroupList', param)
    },

    // 移入小组（可批量操作）
    joinGroupByTeacher(param:object) {
      return post('/CourseGroupApi/joinGroupByTeacher', param)
    },

    // 移出小组（可批量操作）
    removeStudent(param:object) {
      return post('/CourseGroupApi/removeStudent', param)
    },

    // 删除小组
    delGroup(param:object) {
      return post('/CourseGroupApi/delGroup', param)
    },

    // 委任/取消 组长
    setLeader(param:object) {
      return post('/Futurev2/Student/setLeader', param)
    },

    // 修改大组属性
    editGroupActivity(param:object) {
      return post('/CourseGroupActivityApi/editGroupActivity', param)
    },

    // 修改小组属性
    updateGroup(param:object) {
      return post('/CourseGroupApi/updateGroup', param)
    },

    // 获取活动分组详情
    getGroupActivityInfo(param:object) {
      return post('/CourseGroupActivityApi/getGroupActivityInfo', param)
    },

    // 创建大组
    addGroupActivity(param:object) {
      return post('/CourseGroupActivityApi/addGroupActivity', param)
    },

    // 获取班级某学生详情
    getStudentInfo(param:object) {
      return post('/StudentsApi/getStudentInfo', param)
    },

    // 点击加课码-获取已加课人数
    getStudentCount(param:object) {
      return post('/StudentsApi/getStudentCount', param)
    },

    // 获取助教基本信息
    getAssistantInfo(param:object) {
      return post('/AssistantApi/getAssistantInfo', param)
    },

    // 获取vip活动的个人中心的设置
    getUserVipSetting(param:object) {
      return post('/UserApi/getUserVipSetting', param)
    },

    // 移出行政班（可批量操作）[相同于将学生踢出课程]
    kickStudent(param:object) {
      return post('/FutureV2/ClassAdministration/kickStudent', param)
    },

    // 获取行政班列表（包含行政班下学生列表）
    getClassStudentList(param:object) {
      return post('/Futurev2/ClassAdministration/getClassStudentList', param)
    },

    // 获取课程是否允许退课
    getCourseAllowQuit(param:object) {
      return post('/CourseApi/getCourseAllowQuit', param)
    },
    // 设置学生加组权限
    setJoinGroup(param:object) {
      return post('/CourseGroupApi/setJoinGroup', param)
    },
    // 删除某个助教
    delAssistant(param:object) {
      return post('/AssistantApi/delAssistant', param)
    },

}

export default memberApi

